const PROTOCOL_TEMPLATES_AVAILABILITY_CHANGED_EVENT =
  "protocol-templates-availability-changed";

const supportsGlobalEvents = (): boolean => {
  return (
    typeof globalThis !== "undefined" &&
    typeof globalThis.addEventListener === "function" &&
    typeof globalThis.removeEventListener === "function" &&
    typeof globalThis.dispatchEvent === "function"
  );
};

export const notifyProtocolTemplatesAvailabilityChanged = (): void => {
  if (!supportsGlobalEvents()) {
    return;
  }

  globalThis.dispatchEvent(
    new CustomEvent(PROTOCOL_TEMPLATES_AVAILABILITY_CHANGED_EVENT)
  );
};

export const subscribeToProtocolTemplatesAvailabilityChanged = (
  listener: () => void
): (() => void) => {
  if (!supportsGlobalEvents()) {
    return () => undefined;
  }

  const handleAvailabilityChanged = (): void => {
    listener();
  };

  globalThis.addEventListener(
    PROTOCOL_TEMPLATES_AVAILABILITY_CHANGED_EVENT,
    handleAvailabilityChanged
  );

  return () => {
    globalThis.removeEventListener(
      PROTOCOL_TEMPLATES_AVAILABILITY_CHANGED_EVENT,
      handleAvailabilityChanged
    );
  };
};
